import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'glp-dm',
	options: {
		userTags: ['glp'],
	},
	landing: {
		ids: ['glp-app'],
		route: {
			path: '/glp-dm',
			name: 'glp-dm-funnel',
		},
	},
	funnel: {
		id: 'ob-kova-glp-1-app-dm',
		route: {
			path: '/glp-dm/ob/:page(.*)?',
			name: 'glp-dm',
		},
		slug: 'glp-dm',
		locale: ['en'],
	},
	paywall: {
		// Single paywall for both medications. PaywallView resolves the active one from the survey
		// store (the user's pick) or the `?medication` query — not from the route — so there is no
		// per-medication route to override to.
		routeName: 'plan-glp-dm',
	},
}

export default appAreaConfig
